import {
  GET_DOMESTICBANK,
  GET_DOMESTICBANK_SUCCESS,
  GET_DOMESTICBANKS_BY_USERNAME,
  GET_DOMESTICBANKS_BY_USERNAME_SUCCESS,
  DOMESTICBANK_API_ERROR

} from "./actionTypes"

export const getDomesticBankList = record => ({
  type: GET_DOMESTICBANK,
  payload: record,
})

export const getDomesticBankListSuccess = record => ({
  type: GET_DOMESTICBANK_SUCCESS,
  payload: record,
})

export const getPayFacCommissionBankListByUserName = record => ({
  type: GET_DOMESTICBANKS_BY_USERNAME,
  payload: record,
})

export const getPayFacCommissionBankListByUserNameSuccess = record => ({
  type: GET_DOMESTICBANKS_BY_USERNAME_SUCCESS,
  payload: record,
})

export const domesticBankApiError = error => {
  return {
    type: DOMESTICBANK_API_ERROR,
    payload: error,
  }
}

